/* eslint-disable camelcase */
import React from 'react';

import API, { handleApiError } from '../../../lib/api';
import RetailersTable from './Component';
import useDocListState from './state';

import Error from '../../common/ErrorMessage';

function RetailersTableContainer() {
  /*
   * Delete retailer is used to delete from the state cache
   * rather than reload data from the API
   */

  // We'll start our table without any data
  const { retailers, setRetailers, deleteRetailer } = useDocListState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(0);
  const [displayError, setDisplayError] = React.useState();

  const fetchIdRef = React.useRef(0);
  const initialSortBy = [{ id: 'heading', desc: false }];

  const fetchData = React.useCallback(
    async ({ pageSize, pageIndex, searchTerm, sortBy, selectedFilter }) => {
      // Give this fetch an ID
      // eslint-disable-next-line no-plusplus
      const fetchId = ++fetchIdRef.current;

      if (fetchId === fetchIdRef.current) {
        // Set the loading state
        setLoading(true);

        const params = {
          searchTerm,
          pageSize,
          pageIndex,
          live: selectedFilter,
        };

        if (sortBy && sortBy.length > 0) {
          params.sortBy = sortBy[0].id;
          params.sortByDesc = sortBy[0].desc;
        }

        const response = await API.get('retailers/', { params }).catch(
          (error) => {
            handleApiError({ error, setDisplayError });
          },
        );

        if (response) {
          setRetailers(response.data.data);
          setPageCount(Math.ceil(response.data.totalCount / pageSize));
          setTotalCount(response.data.totalCount);
        }

        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const filterOptions = [
    {
      label: 'All',
      value: undefined,
    },
    {
      label: 'Live',
      value: true,
    },
    {
      label: 'Hidden',
      value: false,
    },
  ];

  return (
    <>
      <Error error={displayError} />
      <RetailersTable
        data={retailers}
        isLoading={loading}
        pageCount={pageCount}
        fetchData={fetchData}
        totalCount={totalCount}
        initialSortBy={initialSortBy}
        filterOptions={filterOptions}
        onRetailerDeleted={(retailer_id) => deleteRetailer(retailer_id)}
      />
    </>
  );
}

export default RetailersTableContainer;
